type Props = {
  symbol: string;
  price: string;
};

export const Price = ({ symbol, price }: Props) => {
  return (
    <>
      <span>{symbol}</span>&nbsp;<span>{price}</span>
    </>
  );
};
